import {Component, Input, OnInit} from '@angular/core';
import {ITableColumn} from "../../../../../../shared/shared/table/table-column";
import {IContractCardItem} from "../../contract-card-items.service";
import { CcNameBulkUploadColumnComponent } from './cc-name-bulk-upload-column/cc-name-bulk-upload-column.component';
import { TranslocoService } from '@jsverse/transloco';
import { CcDocumentsBulkUploadColumnComponent } from './cc-documents-bulk-upload-column/cc-documents-bulk-upload-column.component';
import { DocumentStatusesEnum } from 'app/main/pages/documents/dto/document-statuses.enum';

export interface IMatchContractCardsTableItem {
    id: number;
    file: File,
    contract_card: IContractCardItem
}

export interface IImportPDFMapping {
    id: number,
    filename: string,
    contract_card: number
}

export enum BulkImportSummaryTabEnum{
    Categories = "Categories",
    ContractCards = "ContractCards",
    Organizations = "Organizations"

}

export interface ICategorySummaryEntity{
    id: number,
    name: string
}

export interface IOrganizationSummaryEntity{
    id: number,
    name: string
}

export interface IBulkOptionDLLItemsDTO{
    id: number,
    name: string
}

export interface IDocumentsMatching{
    document_number : string;
    id:number;
    name:string;
    status:DocumentStatusesEnum;
    visible_name:string,
    unique_id:string,
    role_id:number
}

export interface IContractCardsSummaryEntity{
    id: number,
    name: string,
    documents: IDocumentsMatching[],
    organization: string,
    category: string
}

@Component({
    selector: 'app-match-contract-cards-step',
    templateUrl: './match-contract-cards-step.component.html',
    styleUrls: ['./match-contract-cards-step.component.scss']
})
export class MatchContractCardsStepComponent implements OnInit {

    @Input() categories: ICategorySummaryEntity[] = [];
    @Input() contractCards: IContractCardsSummaryEntity[]= [];
    @Input() organizations: IOrganizationSummaryEntity[] = [];

    protected BulkImportSummaryTabEnum = BulkImportSummaryTabEnum;

    categoriesColumns: ITableColumn[] = [] ;
    contractControlCardsColumns:ITableColumn[] = [];
    organizationsColumns:ITableColumn[] = [];


    constructor(private _transloco: TranslocoService) {        
    }

    ngOnInit(): void {
        this.setupColumns();
    }

    private setupColumns() {
        this.setupCategoriesColumns()
        this.setupCCColumns();
        this.setupOrganizationsColumns()
    }

    setupCategoriesColumns() {
        this.categoriesColumns = [
            {
                title: this._transloco.translate('Name column title on category tab (bulk upload summary step) - Name'),
                field:'name'
            }
        ];
    }
    setupCCColumns() {
       this.contractControlCardsColumns =[
            {
                title: this._transloco.translate('Name column title on contract card tab (bulk upload summary step) - Name'),
                field:'name',
                cell:CcNameBulkUploadColumnComponent

            },
            {
                title: this._transloco.translate('Documents column title on contract card tab (bulk upload summary step) - Documents'),
                field:'documents',
                cell: CcDocumentsBulkUploadColumnComponent

            },
            {
                title: this._transloco.translate('Organization column title on contract card tab (bulk upload summary step) - Organization'),
                field:'organization'

            },
            {
                title: this._transloco.translate('Category column title on contract card tab (bulk upload summary step) - Category'),
                field:'category'

            }
       ];
    }
    setupOrganizationsColumns() {
        this.organizationsColumns = [
            {
                title: this._transloco.translate('Name column title on organization tab (bulk upload summary step) - Name'),
                field:'name'
            }
        ];
    }

   
}
